(() => {
  const imageOpener = (target) => {
    if (!(target instanceof Element)) return null;
    return target.closest('.product__modal-opener--image');
  };

  document.addEventListener('click', (event) => {
    if (!imageOpener(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (!imageOpener(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
})();
